import clsx from 'clsx'
import {KTSVG, toAbsoluteUrl} from 'helpers'
import {
  // HeaderNotificationsMenu
  HeaderUserMenu,
} from 'components/shared'
import {useLayout} from '../../core'
import {useSelector} from 'react-redux'
import {useState} from 'react'
import OutsideClickHandler from 'react-outside-click-handler'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3'
// const toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px'
const toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'
// const toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar = () => {
  const {config} = useLayout()
  const {user} = useSelector((state) => state.auth)

  const [showUserMenu, setShowUserMenu] = useState(false)

  const toggleUserMenu = () => setShowUserMenu(!showUserMenu)

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary position-relative',
            toolbarButtonHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen022.svg'
            className={toolbarButtonIconSizeClass}
          />
        </div>
        <HeaderNotificationsMenu />
      </div> */}

      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <OutsideClickHandler
          onOutsideClick={() => {
            if (showUserMenu) setShowUserMenu(false)
          }}
        >
          <div
            className={clsx(
              'cursor-pointer symbol',
              toolbarUserAvatarHeightClass,
              showUserMenu && 'show menu-dropdown'
            )}
            onClick={toggleUserMenu}
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <div className='menu-content d-flex align-items-center px-3'>
              <div className='symbol symbol-50px me-5'>
                <img src={user.image || toAbsoluteUrl('/media/avatars/blank.png')} alt='Logo' />
              </div>
              <div className='d-flex flex-column'>
                <div className='fw-bolder d-flex align-items-center fs-5'>{user.name || ''}</div>
                {user.society_name && (
                  <div className='fw-bold text-muted fs-7'>{user.society_name}</div>
                )}
              </div>
            </div>
          </div>
        </OutsideClickHandler>

        <HeaderUserMenu user={user} show={showUserMenu} />
      </div>

      {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </div>
        </div>
      )}
    </div>
  )
}

export {Topbar}
